import React from "react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="bg-gray-950">
      <div className="container mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold text-gray-100 mb-2">Projects</h2>
        <p className="text-gray-500 mb-12 max-w-2xl">
          A selection of projects I've built, from full-stack web apps to
          algorithmic problem solving.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project) => (
            <div
              key={project.title}
              className="border border-gray-800 bg-gray-900 rounded-lg p-6 hover:border-gray-700 transition-colors"
            >
              <h3 className="text-lg font-semibold text-gray-100 mb-2">
                {project.title}
              </h3>
              <p className="text-gray-400 mb-4 text-sm leading-relaxed">
                {project.description}
              </p>
              <div className="flex flex-wrap mb-4">
                {project.tech.map((t) => (
                  <span
                    key={t}
                    className="bg-indigo-900 bg-opacity-40 text-indigo-300 text-xs font-medium mr-2 mb-2 px-2.5 py-0.5 rounded"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <div className="flex space-x-4">
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-indigo-400 hover:text-indigo-300 font-medium"
                  >
                    GitHub &rarr;
                  </a>
                )}
                {project.link && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-indigo-400 hover:text-indigo-300 font-medium"
                  >
                    Live Demo &rarr;
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Projects.js